import { render, staticRenderFns } from "./ThreadView.vue?vue&type=template&id=6cdda850"
import script from "./ThreadView.vue?vue&type=script&lang=js"
export * from "./ThreadView.vue?vue&type=script&lang=js"
import style0 from "./ThreadView.vue?vue&type=style&index=0&id=6cdda850&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports